import FormBillingInfo from 'dashboard/forms/FormBillingInfo';
import { ModalBody, ModalContainer, ModalHeader } from 'dashboard/layouts/ModalLayout';

interface AddBillingInfoModalProps {
  handleClose: () => void;
  handleSubmitBillingInfo: (stripeId: string) => Promise<void>;
  showMessage: (message: string) => void;
}

const AddBillingInfoModal = ({
  handleClose,
  handleSubmitBillingInfo,
  showMessage,
}: AddBillingInfoModalProps) => (
  <ModalContainer data-test='add-billing-info-modal'>
    <ModalHeader data-test='add-billing-info-modal__header' onClose={handleClose}>
      Add credit card or debit card
    </ModalHeader>

    <ModalBody>
      <FormBillingInfo
        handleSubmit={handleSubmitBillingInfo}
        handleClose={handleClose}
        showMessage={showMessage}
      />
    </ModalBody>
  </ModalContainer>
);

export default AddBillingInfoModal;
